<template>
  <div id="app">
    <!-- Loading inicial enquanto carrega dados essenciais -->
    <div v-if="!initialized" class="app-loading">
      <div class="app-loading-spinner"></div>
    </div>

    <!-- Conteúdo real só aparece após dados carregados -->
    <router-view v-if="initialized" />
  </div>
</template>

<script>
import { onMounted } from 'vue'
import { useLandingPage } from '@/composables/useLandingPage'

export default {
  name: 'App',

  setup() {
    const {
      initialized,
      fetchEssentials,
      fetchActiveSections
    } = useLandingPage()

    /**
     * Carregar dados de forma otimizada
     */
    const loadData = async () => {
      // FASE 1: Carregar dados essenciais
      await fetchEssentials()

      // FASE 2: Carregar seções ativas
      setTimeout(() => {
        fetchActiveSections()
      }, 100)
    }

    /**
     * Inicializar apenas uma vez
     */
    onMounted(() => {
      if (!initialized.value) {
        loadData()
      }
    })

    return { initialized }
  }
}
</script>

<style>
@import "styles/reset.css";
@import "styles/index.css";

.app-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100vh;
  width: 100%;
  background: #fff;
}

.app-loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid #e5e7eb;
  border-top-color: #556ee6;
  border-radius: 50%;
  animation: app-spin 0.7s linear infinite;
}

@keyframes app-spin {
  to { transform: rotate(360deg); }
}
</style>
